<template>
    <CustomTable
        :column-form="column_form"
        :tab="true"
        :hideBtnTable="true"
        :hidePagi="true"
    >
        <template v-slot:header>
            <tr v-if="statistical === 1">
                <th rowspan="2">STT</th>
                <th rowspan="2">Phòng GD&amp;ĐT</th>
                <th rowspan="2">Đơn vị</th>
                <th rowspan="2">Sĩ Số</th>
                <th colspan="4">ĐÁNH GIÁ GIÁO DỤC</th>
            </tr>
            <tr v-if="statistical === 1">
                <th rowspan="1">Hoàn thành xuất sắc</th>
                <th rowspan="1">Hoàn thành tốt</th>
                <th rowspan="1">Hoàn thành</th>
                <th rowspan="1">Chưa hoàn thành</th>
            </tr>
        </template>
        <template v-slot:body>
            <tr v-if="statistical === 1">
                <td>1</td>
                <td>12345678910JQK</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>1/1/5</td>
                <td>55</td>
                <td>55</td>
            </tr>
        </template>
    </CustomTable>
</template>

<script>
import CustomTable from '@/components/CustomTable.vue'

export default {
    name: 'EvaluationOfStudentEducation',
    components: {
        CustomTable
    },
    props: {
        statistical: { type: Number, require: true },
        column_form: { type: Number, require: true }
    },

    data() {
        return {
            tableData: []
        }
    },

    methods: {},
    mounted() {},

    computed: {}
}
</script>

<style scoped></style>
